import type { GetAgencyProfileQuery } from '@sortlist-frontend/data-fetching/public-types';
import { Trans } from '@sortlist-frontend/translation/ssr';
import dynamic from 'next/dynamic';
import { FC, Fragment } from 'react';

import { DirectBriefingButton } from '_components/Briefing/versions/DirectBriefing/button';
import { AddToShortListButtonProps } from '_components/Comparator/AddToShortlistButton';
import { ComparedAgency } from '_components/Comparator/utils';

import { SecondaryCTA } from '../SecondaryCta/SecondaryCta';

const AddToShortListButton = dynamic<AddToShortListButtonProps>(
  () => import('_components/Comparator/AddToShortlistButton').then((mod) => mod.AddToShortListButton),
  { ssr: false },
);

const defaultSquareImage = '/_img/default/default-image-landscape.svg';

type Props = {
  agencySlug: string;
  agency: GetAgencyProfileQuery['agency'] | undefined;
  comparedAgencies: ComparedAgency[];
  setComparedAgencies: (agencies: ComparedAgency[]) => void;
  certified?: boolean;
};

export const CallToActions: FC<Props> = (props) => {
  const { agencySlug, agency, comparedAgencies, setComparedAgencies } = props;
  const logo = agency?.logoUrl ?? defaultSquareImage;
  const name = agency?.name as string;

  return (
    <Fragment>
      <DirectBriefingButton
        page="agency"
        className="mb-4 mt-2"
        cta="about-panel"
        truncate={false}
        agencySlug={agencySlug}
        size="md"
        buttonStyle="primary"
        buttonVariant="raised"
        label={<Trans i18nKey={'agency:profile.about.contactCta'}>Contact {{ agencyName: name }}</Trans>}
      />
      <SecondaryCTA
        agencyWebsite={agency?.website as string}
        brandingModule={agency?.paidMember ? 'value_based' : 'free'}
        agencySlug={agencySlug}
        agencyUuid={agency?.uuid as string}
      />
      <AddToShortListButton
        page="profile"
        className="mt-4"
        agency={{ logo, slug: agencySlug, name, external_id: agency?.uuid as string }}
        showName={false}
        searchContext={undefined}
        comparing={comparedAgencies.some((compared) => agency?.slug === compared.slug)}
        onChange={setComparedAgencies}
        comparedAgencies={comparedAgencies}
      />
    </Fragment>
  );
};
